import { Component, OnDestroy, OnInit } from '@angular/core';
import { OfficerDetailFacade } from '@intrensic/shared/officer-details';
import { AgencyDetailsFacade } from '@shared/feature/agency-details';
import { MenuService, UpdateLoggedInOfficerService } from '@intrensic/shell';
import { Subject, takeUntil } from 'rxjs';
import { BaseB2cAuthService } from '@shared/feature/b2c-auth';
import { BaseNavigationService } from '@shared/utils/navigation';

@Component({
    selector: 'angular-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$ = new Subject<void>();

  constructor(
    private auth: BaseB2cAuthService,
    private officerDetailsFacade: OfficerDetailFacade,
    private agencyDetailsFacade: AgencyDetailsFacade,
    private navigationService: BaseNavigationService,
    private updateLoggedInOfficerService: UpdateLoggedInOfficerService,
    private menuService: MenuService
  ) {}

  ngOnInit(): void {
    this.auth.initializeAuth();
    this.menuService.initializeMenuService();
    this.officerDetailsFacade.updateLoggedInOfficer();
    this.agencyDetailsFacade.fetchAgencyDetails();
    this.navigationService
      .navigate()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(() => {});
    this.updateLoggedInOfficerService
      .updateLoggedInOfficerDetails()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(() => {});
  }

  ngOnDestroy(): void {
    this.menuService.onDestroy();
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
